// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import { DirectionalHint, memoizeFunction } from "@fluentui/react";

import type { AppKeytipProps } from "@1js/acui-keytip";
import { getDefaultKeytipProps } from "@1js/acui-keytip";

const tabInMenuOffset = 5; // When in the overflow well, keytip should be positioned 5px from the right of the menu

export const deriveTabMenuKeytip = memoizeFunction(
  (
    keytipProps?: AppKeytipProps,
    onExecute?: (executeTarget: HTMLElement) => void
  ): AppKeytipProps => {
    return keytipProps
      ? getDefaultKeytipProps(
          keytipProps,
          tabInMenuOffset,
          onExecute,
          DirectionalHint.rightCenter
        )
      : undefined;
  }
);
